import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { dispatch } from '../../../store';
import { invalidateProjectsCache } from '../../../store/slices/projects.slice';

const useHttpDeleteProject = (deleteProjectCb: (id: string) => void) => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);

    const execDelete = (id: string) => {
        const { exec, abort } = projectApi.delete({
            params: { id },
            onSuccess: _ => {
                deleteProjectCb(id);
                dispatch(invalidateProjectsCache());
                toastHandler.push('success', t('projects.projectDeletionTitle'), t('projects.projectDeletionMessage_Success'));
            },
            onError: _ => toastHandler.push('error', t('projects.projectDeletionTitle'), t('projects.addAssigneesMessage_Failed')),
        });
        exec();
        return abort;
    };

    return { execDelete };
};

export default useHttpDeleteProject;
